var x = Object.defineProperty, C = Object.defineProperties;
var I = Object.getOwnPropertyDescriptors;
var e = Object.getOwnPropertySymbols;
var i = Object.prototype.hasOwnProperty, y = Object.prototype.propertyIsEnumerable;
var f = (r, o, p) => o in r ? x(r, o, { enumerable: !0, configurable: !0, writable: !0, value: p }) : r[o] = p, n = (r, o) => {
  for (var p in o || (o = {}))
    i.call(o, p) && f(r, p, o[p]);
  if (e)
    for (var p of e(o))
      y.call(o, p) && f(r, p, o[p]);
  return r;
}, T = (r, o) => C(r, I(o));
var s = (r, o) => {
  var p = {};
  for (var t in r)
    i.call(r, t) && o.indexOf(t) < 0 && (p[t] = r[t]);
  if (r != null && e)
    for (var t of e(r))
      o.indexOf(t) < 0 && y.call(r, t) && (p[t] = r[t]);
  return p;
};
import { jsx as d } from "react/jsx-runtime";
import N from "react";
import P from "react-wrap-balancer";
import * as _ from "./style.es.js";
import { Typography as E } from "./style.es.js";
import { TYPOGRAPHY_VARIANT as H } from "../../constants/typography.es.js";
import { SEMANTICS_COLOR as L, COLOR_EMPHASIS as M } from "../../constants/color.es.js";
const l = N.forwardRef((Y, S) => {
  var m = Y, {
    children: r,
    variant: o = H.body1,
    color: p = L.fg,
    emphasis: t = M.default,
    withBalancer: R = !1,
    fontFamily: c,
    underline: g,
    lineThrough: h,
    uppercase: u,
    hoverUnderline: A
  } = m, O = s(m, [
    "children",
    "variant",
    "color",
    "emphasis",
    "withBalancer",
    "fontFamily",
    "underline",
    "lineThrough",
    "uppercase",
    "hoverUnderline"
  ]);
  function a() {
    return /* @__PURE__ */ d(E, T(n({ variant: o, color: p, emphasis: t }, O), { fontFamily: c, underline: g, lineThrough: h, uppercase: u, hoverUnderline: A, ref: S, children: r }));
  }
  return R ? /* @__PURE__ */ d(P, { children: a() }) : a();
});
l.S = _;
l.displayName = "Typography";
export {
  l as Typography
};
//# sourceMappingURL=Typography.es.js.map
